export default __webpack_public_path__ + "static/media/DiceRolling.509696e0.mp4";